module.exports = __webpack_public_path__ + "img/aej1n-66wvl.036.da5c5c8b.png";